import type { TextPredictionButtonFragment } from "../../client/generated";
import { useAuth } from "react-oidc-context";
import { predictText } from "../../client/predictions";
import { useTranslation } from "react-i18next";
import { PredictionButton } from "../../predictions/PredictionButton";

type Props = {
  fragment: TextPredictionButtonFragment;
  onAccept: (prediction: string) => void;
};

export function TextPredictionButton({ fragment, onAccept }: Props) {
  const { t } = useTranslation();
  const auth = useAuth();

  const predict = async () => {
    if (!fragment.page.pngUrl || !auth.user) return;

    return await predictText(
      fragment.page.pngUrl,
      auth.user.access_token,
      fragment.shape.aabb,
    );
  };

  return (
    <PredictionButton
      label={t("TextPredictionButton.label")}
      onPredict={predict}
      onAccept={onAccept}
    />
  );
}
